/**
 * EmptyState — per UX_GUIDE_UNIFIED.md
 *
 * Every chart and table must have an explicit empty state.
 * Structure: icon — short declarative title — one-line suggestion.
 * Centered, text-muted.
 */

import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    textAlign: 'center',
    gap: '8px',
  },
  icon: {
    fontSize: '32px',
    marginBottom: '4px',
    color: 'var(--text-muted)',
  },
  title: {
    fontSize: '14px',
    fontWeight: 500,
    color: 'var(--text-secondary)',
  },
  suggestion: {
    fontSize: '13px',
    color: 'var(--text-muted)',
  },
});

export interface EmptyStateProps {
  icon?: string;
  title: string;
  suggestion?: string;
}

export function EmptyState({
  icon = '\u2014',
  title,
  suggestion,
}: EmptyStateProps) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{title}</div>
      {suggestion && <div className={styles.suggestion}>{suggestion}</div>}
    </div>
  );
}
